module.exports = __webpack_public_path__ + "static/logo-slap-digital-violet-2e8c864e9b42af772e45c8e8763956bd.png";